<template>
  <li class="filter-option">
    <a
      v-if="brandUrl"
      :href="'/' + brandUrl + '/'"
      class="filter-option__link"
      :class="{ 'filter-option__link--active': option.toBeSelected }"
      @click.prevent="$emit('option-toggle', { option, filter })"
    >
      <span
        class="filter-option__input checkbox"
        :class="{ 'checkbox--checked': option.selected }"
      />

      <span class="filter-option__label">
        <span
          v-if="filter.selectionType === 'color'"
          class="filter-option__swatch"
          :style="swatchBg(option)"
          aria-hidden="true"
        />
        <span class="filter-option__name">{{ label }}</span>
        <span
          v-if="filter.isNrOfResultsVisible"
          class="filter-option__count"
          aria-hidden="true"
        >{{ option.count }}
        </span>
      </span>
    </a>
    <template v-else>
      <input
        :id="`filter-${filter.key}-${option.key}`"
        type="checkbox"
        class="filter-option__input"
        :checked="option.selected"
        @input="$emit('option-toggle', { option, filter })"
      >
      <label
        class="filter-option__label"
        :for="`filter-${filter.key}-${option.key}`"
      >
        <span
          v-if="filter.selectionType === 'color'"
          class="filter-option__swatch"
          :style="swatchBg(option)"
        />
        <span class="filter-option__name">{{ label }}</span>
        <span
          v-if="filter.isNrOfResultsVisible"
          class="filter-option__count"
          aria-hidden="true"
        >
          {{ option.count }}
        </span>
      </label>
    </template>
  </li>
</template>

<script setup lang="ts">
export type Props = {
  option: any
  filter: any
}

const props = defineProps<Props>()
defineEmits(['option-toggle'])

const { getBrandUrl } = useBrands()
const label = computed(() => props.option.label)

const brandUrl = computed(() => {
  if (props.filter.key !== 'tra_brand') return null
  return getBrandUrl(props.option.key)
})

function swatchBg(option: any) {
  if (['multicolor', 'mehrfarbig'].includes(option.key.toLowerCase())) {
    return {
      backgroundBlendMode: 'screen',
      backgroundImage: `
        radial-gradient(circle closest-side, white, black 90%),
        conic-gradient(red, #ff8000, yellow, #80ff00, lime, #00ff80, aqua, #0080ff, blue, #8000ff, fuchsia, #ff0080, red)
      `,
    }
  }

  return {
    backgroundColor: option.swatch ?? colormapping[option.key.toLowerCase()],
  }
}

const colormapping = {
  'beige': '#e8dcca',
  'blauw': '#0000ff',
  'blue': '#0000ff',
  'blau': '#0000ff',
  'brons': '#b08c57',
  'bronze': '#b08c57',
  'bruin': '#a35910',
  'brown': '#a35910',
  'braun': '#a35910',
  'champagne': '#f7e7ce',
  'champagner': '#f7e7ce',
  'cognac': '#bb6244',
  'geel': '#ffff00',
  'yellow': '#ffff00',
  'gelb': '#ffff00',
  'goud': '#d4af37',
  'gold': '#d4af37',
  'grijs': '#787878',
  'grey': '#787878',
  'grau': '#787878',
  'groen': '#008000',
  'green': '#008000',
  'grün': '#008000',
  'oranje': '#ffa600',
  'orange': '#ffa600',
  'paars': '#4c00b0',
  'purple': '#4c00b0',
  'violett': '#4c00b0',
  'rood': '#ff0000',
  'red': '#ff0000',
  'rot': '#ff0000',
  'rose goud': '#ecc5c0',
  'rose_gold': '#ecc5c0',
  'rose gold': '#ecc5c0',
  'roze': '#ff10ef',
  'pink': '#ff10ef',
  'rosa': '#ff10ef',
  'taupe': '#b6ab9e',
  'wit': '#ffffff',
  'white': '#ffffff',
  'weiss': '#ffffff',
  'zand': '#e7d7be',
  'sand': '#e7d7be',
  'zilver': '#c0c0c0',
  'silver': '#c0c0c0',
  'silber': '#c0c0c0',
  'zwart': '#030303',
  'black': '#030303',
  'schwarz': '#030303',
}
</script>

<style>
@import url("~layers/app/components/Filter/Option.css");
</style>
